import store from "@/store";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/auth",
    redirect: "/login",
    component: () => import("@/layouts/FullPage"),
    children: [
      {
        path: "/login",
        name: "Login",
        meta: {
          layout: "layout-full",
          permissionCode: "public",
        },
        component: () => import("@/views/auth/Login.vue"),
      },
      {
        path: "/forgot-password",
        name: "ForgotPassword",
        meta: {
          layout: "layout-full",
          permissionCode: "public",
        },
        component: () => import("@/views/auth/ForgotPassword.vue"),
      },
      {
        path: "/set-password",
        name: "SetPassword",
        meta: {
          layout: "layout-full",
          permissionCode: "public",
        },
        component: () => import("@/views/auth/SetPassword.vue"),
      },
      {
        path: "/reset-otp",
        name: "ResetOtp",
        meta: {
          layout: "layout-full",
          permissionCode: "public",
        },
        component: () => import("@/views/auth/ResetOtp.vue"),
      },
    ],
  },
  {
    path: "",
    component: () => import("@/layouts/Main"),
    children: [
      {
        path: "/",
        name: "Dashboard",
        meta: {
          layout: "layout-full",
          permissionCode: "dashboard",
        },
        component: () => import("@/views/Dashboard.vue"),
      },
      {
        path: "/users",
        name: "Users",
        meta: {
          layout: "layout-full",
          permissionCode: "user",
        },
        component: () => import("@/views/auth/Users.vue"),
      },
      {
        path: "/hr/personal-information/:id([\\w-]+)?",
        name: "Personal Information",
        meta: {
          layout: "layout-full",
          permissionCode: "personal_information",
          dynamic: true,
        },
        component: () => import("@/views/hr/PersonalInformation.vue"),
      },
      {
        path: "/hr/employees",
        name: "Employees",
        meta: {
          layout: "layout-full",
          permissionCode: "employees",
        },
        component: () => import("@/views/hr/Employees.vue"),
      },
      {
        path: "/hr/leaves",
        name: "Leaves",
        meta: {
          layout: "layout-full",
          permissionCode: "employee_leave_request",
        },
        component: () => import("@/views/hr/Leaves.vue"),
      },
      {
        path: "/hr/leaves/:id([\\w-]+)?",
        name: "Leaves Mail",
        meta: {
          layout: "layout-full",
          permissionCode: "employee_leave_request",
        },
        component: () => import("@/views/hr/Leaves.vue"),
      },
      {
        path: "/hr/bulkleaves",
        name: "Bulk Leaves",
        meta: {
          layout: "layout-full",
          permissionCode: "bulk_leaves",
        },
        component: () => import("@/views/hr/BulkLeaves.vue"),
      },
      {
        path: "/hr/leavelist",
        name: "Leave List",
        meta: {
          layout: "layout-full",
          permissionCode: "employee_leave_list",
        },
        component: () => import("@/views/hr/LeaveList.vue"),
      },
      {
        path: "/hr/holidays",
        name: "Holidays",
        meta: {
          layout: "layout-full",
          permissionCode: "holidays",
        },
        component: () => import("@/views/hr/Holidays.vue"),
      },
      {
        path: "/hr/manager-reports",
        name: "Manager Reports",
        meta: {
          layout: "layout-full",
          permissionCode: "employee_with_managers",
        },
        component: () => import("@/views/hr/HrReports.vue"),
      },
      {
        path: "/hr/yearlyleavereports",
        name: "Yearly Leave Reports",
        meta: {
          layout: "layout-full",
          permissionCode: "yearly_leave_reports",
        },
        component: () => import("@/views/hr/YearlyLeaveReports.vue"),
      },
      {
        path: "/hr/officeusagereport",
        name: "Office Usage Report",
        meta: {
          layout: "layout-full",
          permissionCode: "office_usage_report",
        },
        component: () => import("@/views/hr/OfficeUsageReport.vue"),
      },
      {
        path: "/capacity/team-management",
        name: "Teams Management",
        meta: {
          layout: "layout-full",
          permissionCode: "team_management",
        },
        component: () => import("@/views/hr/Teams.vue"),
      },
      {
        path: "/employee-leaves/:id([\\w-]+)",
        name: "Employee Leaves",
        meta: {
          layout: "layout-full",
          permissionCode: "employee_leave_list",
          dynamic: true,
        },
        component: () => import("@/views/hr/EmployeeLeaves.vue"),
      },
      {
        path: "/customers",
        name: "Customers",
        meta: {
          layout: "layout-full",
          permissionCode: "customer",
        },
        component: () => import("@/views/auth/Customers.vue"),
      },
      {
        path: "/stakeholders",
        name: "Stakeholders",
        meta: {
          layout: "layout-full",
          permissionCode: "provider",
        },
        component: () => import("@/views/auth/Providers.vue"),
      },
      {
        path: "/targets",
        name: "Targets",
        meta: {
          layout: "layout-full",
          permissionCode: "target",
        },
        component: () => import("@/views/opportunity/Targets.vue"),
      },
      {
        path: "/budget/expense-parameters",
        name: "Expense Parameters",
        meta: {
          layout: "layout-full",
          permissionCode: "expense_parameters",
        },
        component: () => import("@/views/budget/BudgetExpense.vue"),
      },
      {
        path: "/budget/expense-parameter/:id([\\w-]+)",
        name: "Expense Details",
        meta: {
          layout: "layout-full",
          permissionCode: "expense_parameters",
        },
        component: () => import("@/views/budget/ExpenseDetails.vue"),
      },
      {
        path: "/budget/exchange-rates",
        name: "Exchange Rates",
        meta: {
          layout: "layout-full",
          permissionCode: "exchange_rates",
        },
        component: () => import("@/views/budget/Currency.vue"),
      },
      {
        path: "/budget/planned-budgets/:id([\\w-]+)",
        name: "Budget Planning",
        meta: {
          layout: "layout-full",
          permissionCode: "planned_budgets",
        },
        component: () => import("@/views/budget/BudgetPlanning.vue"),
      },
      {
        path: "/budget/planned-budget/new-budget-planning",
        name: "New Budget Planning",
        meta: {
          layout: "layout-full",
          permissionCode: "planned_budgets",
        },
        component: () => import("@/views/budget/BudgetPlanning.vue"),
      },
      {
        path: "/budget/planned-budgets",
        name: "Planned Budgets",
        meta: {
          layout: "layout-full",
          permissionCode: "planned_budgets",
        },
        component: () => import("@/views/budget/PlannedBudgets.vue"),
      },
      {
        path: "/budget/virtual-departments",
        name: "Virtual Departments",
        meta: {
          layout: "layout-full",
          permissionCode: "virtual_department",
        },
        component: () => import("@/views/budget/VirtualDepartment.vue"),
      },
      {
        path: "/budget/receivable-reports",
        name: "Receivable Reports",
        meta: {
          layout: "layout-full",
          permissionCode: "receivable_report",
        },
        component: () => import("@/views/budget/ReceivableReports.vue"),
      },
      {
        path: "/budget/receivable-reports/:id([\\w-]+)",
        name: "Receivable Report",
        meta: {
          layout: "layout-full",
          permissionCode: "receivable_report",
          dynamic: true,
        },
        component: () => import("@/views/budget/ReceivableReport.vue"),
      },
      {
        path: "/budget/barikat-divisions",
        name: "Barikat Divisions",
        meta: {
          layout: "layout-full",
          permissionCode: "barikat_division",
        },
        component: () => import("@/views/budget/BarikatDivisions.vue"),
      },
      {
        path: "/budget/plan-status-reports",
        name: "Plan Status Reports",
        meta: {
          layout: "layout-full",
          permissionCode: "plan_status_reports",
        },
        component: () => import("@/views/budget/PlanStatusReport.vue"),
      },
      {
        path: "/budget/summary-budget-report",
        name: "Summary Budget Report",
        meta: {
          layout: "layout-full",
          permissionCode: "summary_budget_report",
        },
        component: () => import("@/views/budget/SummaryBudgetReport.vue"),
      },
      {
        path: "/budget_management/detailed-budget-report",
        name: "Detailed Budget Report",
        meta: {
          layout: "layout-full",
          permissionCode: "detailed_budget_report",
        },
        component: () => import("@/views/DetailedBudgetReport.vue"),
      },
      {
        path: "/budget/fuel-limit-for-title",
        name: "Fuel Limit for Title",
        meta: {
          layout: "layout-full",
          permissionCode: "fuel_limits_for_title",
        },
        component: () => import("@/views/budget/FuelLimitForTitle.vue"),
      },
      {
        path: "/budget/bank-balances",
        name: "Bank Balances",
        meta: {
          layout: "layout-full",
          permissionCode: "bank_balance_report",
        },
        component: () => import("@/views/budget/BankBalances.vue"),
      },
      {
        path: "/budget/bank-balances/:id([\\w-]+)",
        name: "BankBalance",
        meta: {
          layout: "layout-full",
          permissionCode: "bank_balance_report",
          dynamic: true,
        },
        component: () => import("@/views/budget/BankBalance.vue"),
      },
      {
        path: "/budget/actual-budgets",
        name: "Actual Budgets",
        meta: {
          layout: "layout-full",
          permissionCode: "actual_budget",
        },
        component: () => import("@/views/budget/ActualBudget.vue"),
      },
      {
        path: "/budget/actual-budgets/history/:id([\\w-]+)",
        name: "Actual Budget List",
        meta: {
          layout: "layout-full",
          permissionCode: "actual_budget",
        },
        component: () => import("@/views/budget/ActualBudgetList.vue"),
      },
      {
        path: "/budget/actual-budgets/:id([\\w-]+)",
        name: "Actual Budget Detail",
        component: () => import("@/views/budget/ActualBudgetDetail.vue"),
        meta: {
          layout: "layout-full",
          permissionCode: "actual_budget",
        },
      },
      {
        path: "/budget/actual-budget-graphs/:id([\\w-]+)",
        name: "Actual Budget Graphs",
        component: () => import("@/views/budget/ActualBudgetGraphs.vue"),
        meta: {
          layout: "layout-full",
          permissionCode: "actual_budget",
        },
      },
      {
        path: "/budget/receipts-and-payments",
        name: "Collections And Payments",
        meta: {
          layout: "layout-full",
          permissionCode: "collections_and_payments",
        },
        component: () => import("@/views/budget/CollectionsAndPayments.vue"),
      },
      {
        path: "/budget/all-budget-reports",
        name: "All Budget Reports",
        meta: {
          layout: "layout-full",
          permissionCode: "all_budget_reports",
        },
        component: () => import("@/views/budget/AllBudgetReports.vue"),
      },
      {
        path: "/budget/budget-reports-by-month",
        name: "All Budget Reports By Month",
        meta: {
          layout: "layout-full",
          permissionCode: "all_monthly_reports",
        },
        component: () => import("@/views/budget/AllBudgetByMonth.vue"),
      },
      {
        path: "/budget/personnel-reports",
        name: "Personnel Reports",
        meta: {
          layout: "layout-full",
          permissionCode: "personnel_reports",
        },
        component: () => import("@/views/budget/PersonnelReports.vue"),
      },
      {
        path: "/budget/collections-and-payments/:id([\\w-]+)",
        name: "CollectionAndPayment",
        meta: {
          layout: "layout-full",
          permissionCode: "collections_and_payments",
          dynamic: true,
        },
        component: () => import("@/views/budget/CollectionAndPayment.vue"),
      },
      {
        path: "/budget/planned-personnel",
        name: "Planned Personnel",
        meta: {
          layout: "layout-full",
          permissionCode: "planned_personnels",
        },
        component: () => import("@/views/budget/PlannedPersonnels.vue"),
      },
      {
        path: "/budget/planned-personnel/personnel-planning/:id([\\w-]+)",
        name: "Personnel Planning",
        meta: {
          layout: "layout-full",
          permissionCode: "planned_personnels",
        },
        component: () => import("@/views/budget/PersonnelPlanning.vue"),
      },
      {
        path: "/budget/planned-personnel/new-personnel-planning/",
        name: "New Personnel Planning",
        meta: {
          layout: "layout-full",
          permissionCode: "planned_personnels",
        },
        component: () => import("@/views/budget/PersonnelPlanning.vue"),
      },
      {
        path: "/customer/:id([\\w-]+)/:tab?",
        name: "Customer",
        meta: {
          layout: "layout-full",
          permissionCode: "customer",
          dynamic: true,
        },
        component: () => import("@/views/auth/Customer.vue"),
      },
      {
        path: "/stakeholder/:id([\\w-]+)/:tab?",
        name: "Stakeholder",
        meta: {
          layout: "layout-full",
          permissionCode: "provider",
          dynamic: true,
        },
        component: () => import("@/views/auth/Provider.vue"),
      },
      {
        path: "/client/:id([\\w-]+)",
        name: "Client",
        meta: {
          layout: "layout-full",
          permissionCode: "client",
          dynamic: true,
        },
        component: () => import("@/views/profile/Client.vue"),
      },
      {
        path: "/admin",
        name: "Admin",
        meta: {
          layout: "layout-full",
          permissionCode: "admin",
        },
        component: () => import("@/views/profile/Admin.vue"),
      },
      {
        path: "/project/projects",
        name: "Projects",
        meta: {
          layout: "layout-full",
          permissionCode: "projects",
        },
        component: () => import("@/views/project/Projects.vue"),
      },
      {
        path: "/project/data-destruction-dashboard",
        name: "Data Destruction Dashboard",
        meta: {
          layout: "layout-full",
          permissionCode: "project_data_destruction_dashboard",
        },
        component: () => import("@/views/project/DataDestructionDashboard.vue"),
      },
      {
        path: "/opportunity-projects",
        name: "Opportunity Projects",
        meta: {
          layout: "layout-full",
          permissionCode: "opportunity_project",
        },
        component: () => import("@/views/opportunity/OpportunityProjects.vue"),
      },
      {
        path: "/opportunity-project/:id([\\w-]+)",
        name: "Opportunity Project",
        meta: {
          layout: "layout-full",
          permissionCode: "opportunity_project",
          dynamic: true,
        },
        component: () => import("@/views/opportunity/OpportunityProject.vue"),
      },
      {
        path: "/project/:id([\\w-]+)",
        name: "Project",
        meta: {
          layout: "layout-full",
          permissionCode: "projects",
          dynamic: true,
        },
        component: () => import("@/views/project/Project.vue"),
      },
      {
        path: "/projectmanagement/:id([\\w-]+)",
        name: "ProjectManagement",
        meta: {
          layout: "layout-full",
          permissionCode: "project_project_management",
          dynamic: true,
        },
        component: () => import("@/views/project/ProjectManagement.vue"),
      },
      {
        path: "/ticket/tickets",
        name: "Tickets",
        meta: {
          layout: "layout-full",
          permissionCode: "tickets",
        },
        component: () => import("@/views/project/Tickets.vue"),
      },
      {
        path: "/ticket/onboarding",
        name: "Onboarding",
        meta: {
          layout: "layout-full",
          permissionCode: "onboarding",
        },
        component: () => import("@/views/project/Onboarding.vue"),
      },
      {
        path: "/ticket/dashboard",
        name: "Ticket Dashboard",
        meta: {
          layout: "layout-full",
          permissionCode: "ticket_dashboard",
        },
        component: () => import("@/views/project/TicketDashboard.vue"),
      },
      {
        path: "/ticket/dashboard-2",
        name: "Ticket Dashboard-2",
        meta: {
          layout: "layout-full",
          permissionCode: "ticket_dashboard_2",
        },
        component: () => import("@/views/project/TicketDashboard2.vue"),
      },
      {
        path: "/products",
        name: "Products",
        meta: {
          layout: "layout-full",
          permissionCode: "products_product_history",
        },
        component: () => import("@/views/project/SparePart.vue"),
      },
      {
        path: "/notifications",
        name: "Notifications",
        meta: {
          layout: "layout-full",
          permissionCode: "tickets",
        },
        component: () => import("@/views/Notifications.vue"),
      },
      {
        path: "/capacity/calendar",
        name: "Calendar",
        meta: {
          layout: "layout-full",
          permissionCode: "capacity_calendar",
        },
        component: () => import("@/views/project/Calendar.vue"),
      },
      {
        path: "/capacity/reports",
        name: "Reports",
        meta: {
          layout: "layout-full",
          permissionCode: "capacity_capacity_reports",
        },
        component: () => import("@/views/project/CapacityReport.vue"),
      },
      {
        path: "/capacity/waiting_approval",
        name: "Waiting Approval",
        meta: {
          layout: "layout-full",
          permissionCode: "waiting_approval",
        },
        component: () => import("@/views/project/WaitingApproval.vue"),
      },
      {
        path: "/capacity/yearly-report-person",
        name: "Yearly Report Person",
        meta: {
          layout: "layout-full",
          permissionCode: "capacity_yearly_report_person",
        },
        component: () =>
          import("@/views/project/CapacityYearlyReportPerson.vue"),
      },
      {
        path: "/capacity/activity-tracking",
        name: "Activity Tracking",
        meta: {
          layout: "layout-full",
          permissionCode: "activity_tracking",
        },
        component: () => import("@/views/WorklogReport.vue"),
      },
      /**
             {
             path: "/inventory",
             name: "Inventory",
             meta: {
             layout: "layout-full",
             },
             component: () => import("@/views/Inventory.vue"),
             },
             **/
      {
        path: "/settings/roles-permissions",
        name: "RolesPermissions",
        meta: {
          layout: "layout-full",
          permissionCode: "roles_permissions",
        },
        component: () => import("@/views/settings/RolesPermissions.vue"),
      },
      {
        path: "/settings/custom-permissions",
        name: "CustomPermissions",
        meta: {
          layout: "layout-full",
          permissionCode: "custom_permissions",
        },
        component: () => import("@/views/settings/CustomPermissions.vue"),
      },
      {
        path: "/settings/departments",
        name: "Departments",
        meta: {
          layout: "layout-full",
          permissionCode: "departments",
        },
        component: () => import("@/views/settings/Departments.vue"),
      },
      {
        path: "/settings/parameters",
        name: "Parameters",
        meta: {
          layout: "layout-full",
          permissionCode: "parameters",
        },
        component: () => import("@/views/settings/Parameters.vue"),
      },
      {
        path: "/settings/sku",
        name: "Sku",
        meta: {
          layout: "layout-full",
          permissionCode: "sku",
        },
        component: () => import("@/views/settings/Sku.vue"),
      },
      {
        path: "/settings/logs",
        name: "Logs",
        meta: {
          layout: "layout-full",
          permissionCode: "logs",
        },
        component: () => import("@/views/settings/Logs.vue"),
      },
      {
        path: "/settings/sync-logs",
        name: "SyncLogs",
        meta: {
          layout: "layout-full",
          permissionCode: "logs",
        },
        component: () => import("@/views/settings/SyncLogs.vue"),
      },
      {
        path: "/settings/system-jobs",
        name: "SystemJobs",
        meta: {
          layout: "layout-full",
          permissionCode: "roles_permissions",
        },
        component: () => import("@/views/settings/SystemJobs.vue"),
      },
      {
        path: "/settings/issues-types",
        name: "IssueTypes",
        meta: {
          layout: "layout-full",
          permissionCode: "issue_types",
        },
        component: () => import("@/views/settings/IssueTypes.vue"),
      },
      {
        path: "/settings/issues-states",
        name: "IssueStates",
        meta: {
          layout: "layout-full",
          permissionCode: "issue_states",
        },
        component: () => import("@/views/settings/IssueStates.vue"),
      },
      {
        path: "/settings/application-settings",
        name: "ApplicationSettings",
        meta: {
          layout: "layout-full",
          permissionCode: "roles_permissions",
        },
        component: () => import("@/views/settings/ApplicationSettings.vue"),
      },
      {
        path: "/hr/employee/:id([\\w-]+)",
        name: "Employee",
        meta: {
          layout: "layout-full",
          permissionCode: "employees",
          dynamic: true,
        },
        component: () => import("@/views/hr/EmployeeDetail.vue"),
      },
      {
        path: "/reports/project",
        name: "ProjectReports",
        meta: {
          layout: "layout-full",
          permissionCode: "project_reports",
        },
        component: () => import("@/views/reports/Project.vue"),
      },
      {
        path: "/ticket/company-technology",
        name: "Company Technology Report",
        meta: {
          layout: "layout-full",
          permissionCode: "settings",
        },
        component: () => import("@/views/reports/CompanyTechnology.vue"),
      },
      {
        path: "/reports/service",
        name: "Service Report",
        meta: {
          layout: "layout-full",
          permissionCode: "settings",
        },
        component: () => import("@/views/reports/Service.vue"),
      },
      {
        path: "/ticket/ticket-type-report",
        name: "Ticket Type Report",
        meta: {
          layout: "layout-full",
          permissionCode: "settings",
        },
        component: () => import("@/views/reports/TicketType.vue"),
      },
      {
        path: "/ticket/ticket-report",
        name: "Ticket Report",
        meta: {
          layout: "layout-full",
          permissionCode: "settings",
        },
        component: () => import("@/views/reports/Ticket.vue"),
      },
      {
        path: "/ticket/task",
        name: "Task Report",
        meta: {
          layout: "layout-full",
          permissionCode: "settings",
        },
        component: () => import("@/views/reports/Task.vue"),
      },
      {
        path: "/reports/overexertion-report",
        name: "Overexertion Report",
        meta: {
          layout: "layout-full",
          permissionCode: "overexertion_report",
        },
        component: () => import("@/views/reports/overexertionReport.vue"),
      },
      {
        path: "/data-destruction",
        name: "Data Destruction",
        meta: {
          layout: "layout-full",
          permissionCode: "data_destruction",
        },
        component: () => import("@/views/DataDestruction.vue"),
      },
    ],
  },
  {
    path: "/404",
    name: "NotFoundD",
    meta: {
      layout: "layout-full",
    },
    component: () => import("@/views/404.vue"),
  },
  {
    path: "*",
    name: "NotFound",
    redirect: "/404",
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  const publicPages = [
    "/login",
    "/forgot-password",
    "/set-password",
    "/reset-otp",
  ];

  store.commit("addRouteToHistory", to.path);
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("token");
  let user = store.state.auth.user;
  const currentRole = store.state.auth.currentRole;

  if (authRequired && !loggedIn) {
    return next("/login");
  } else {
    if (loggedIn && !user) {
      store
        .dispatch("auth/fetchCurrentUser")
        .then((res) => {
          store.commit("auth/SET_CURRENT_USER", res);
          user = res;
          const permissions =
            currentRole === 1 ? res.permissions : res.permissions2;

          const hasNotificationPermission =
            user.is_superuser || permissions?.read?.includes("ticket_comment");
          if (authRequired && hasNotificationPermission)
            store.dispatch("tickets/fetchTicketNotifications");

          if (res.is_superuser) {
            next();
            return;
          }
          if (
            window.location.href.includes(user?.ticket_domain) &&
            to.meta.isTicket
          ) {
            next("/404");
          } else if (permissions?.read?.includes(to.meta.permissionCode)) {
            next();
          } else if (to.path === "/" || to.path === "") {
            let permission_routes = (routes[1]?.children || []).filter(
              (path) => {
                if (
                  permissions?.read?.includes(path.meta.permissionCode) &&
                  !path.meta.dynamic
                ) {
                  return path;
                }
              },
            );

            if (permission_routes.length > 0) {
              next(permission_routes[0].path);
            } else if (user.is_superuser) {
              next();
            } else {
              next("/404");
            }
          } else {
            next("/404");
          }
        })
        .catch(() => {
          const stillLoggedIn = localStorage.getItem("token");

          if (authRequired && to.path !== "/login" && stillLoggedIn) {
            next("/login");
          } else if (!stillLoggedIn && to.path !== "/login") {
            next(false);
          } else {
            next();
          }
        });
    } else {
      next();
    }
  }
});
export default router;
